module.exports = __webpack_public_path__ + "media/images/tablet-9f7c892be12c01c7013377c652874b4e.png";